import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable, catchError } from 'rxjs';
import { GlobalServicesService } from './global-services.service';

@Injectable({
  providedIn: 'root'
})
export class JobServicesService {

  host_api_url = environment.HOST.HOST_API_URL;
  fast_api_url = environment.HOST.FAST_API_URL;
  hire_pulse_url = environment.HOST.HIRE_PULSE_URL;


  constructor(private http: HttpClient,private globalService: GlobalServicesService) { }

  //Fast APIs
  getUsersFastApi(page = 1, size = 10, orderBy = 'asc', sortBy = 'id', search = ""): Observable<HttpResponse<any>> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('order_by', orderBy)
      .set('sort_by', sortBy);
    if (search && search.trim() !== '') {
      params = params.set('s', search.trim());
    }

    return this.http.get<HttpResponse<any>>(`${this.fast_api_url}/users`, {
      params,
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  getUserByIdFastApi(userId: string): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(`${this.fast_api_url}/users/${userId}`, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  getUserByRoleIdFastApi(roleId: string): Observable<HttpResponse<any>> {
    const params = new HttpParams().set('role_id', roleId);
    return this.http.get<HttpResponse<any>>(`${this.fast_api_url}/users/list`, {
      params,
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
}

  createUserFastApi(payload: any): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(`${this.fast_api_url}/users`, payload, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  updateUserFastApi(payload: any, userId: string): Observable<HttpResponse<any>> {
    return this.http.put<HttpResponse<any>>(`${this.fast_api_url}/users/${userId}`, payload, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  deleteUserFastApi(userId: string): Observable<HttpResponse<any>> {
    return this.http.delete<HttpResponse<any>>(`${this.fast_api_url}/users/${userId}`, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  getUserFormDataFastApi(): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(`${this.fast_api_url}/users/form-data`, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  //Candidate Fast APIs
  getCandidatesFastApi(eventId: string, page = 1, size = 10, orderBy = 'asc', sortBy = 'candidate_uuid', search?: any, filterCriteria?: any[]): Observable<HttpResponse<any>> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('order_by', orderBy)
      .set('sort_by', sortBy);
      if (search && search.trim() !== '') {
        params = params.set('s', search.trim());
      }

    const fieldMapping: { [key: string]: string } = {
      jobRole: "job_role_id",
      jobStatus: "status",
      gender: "gender",
      degree: "degree",
      specialization: "specialization",
      collegeName: "college_name",
      stage: "stage_uuid",
      alignmentCategory: "alignment_category"
    };

    if (filterCriteria && filterCriteria.length > 0) {
      filterCriteria.forEach((filter: any) => {
        if (filter.filterValue != null && filter.filterValue !== '') {
          if (filter.filterField === "candidate_source_id") {
            filter.filterValue = filter.filterValue.join(",")
          }

          if (Array.isArray(filter.filterValue) && filter.filterValue.length > 0) {
            filter.filterValue.forEach((value: any) => {
              const mappedField = fieldMapping[filter.filterField] || filter.filterField;
              params = params.append(mappedField, value);
            });
          } else if (!Array.isArray(filter.filterValue)) {
            const mappedField = fieldMapping[filter.filterField] || filter.filterField;
            params = params.set(mappedField, filter.filterValue);
          }
        }
      });
    }

    return this.http.get<HttpResponse<any>>(`${this.fast_api_url}/events/${eventId}/candidates`, {
      params,
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  // Stage Fast APIs
  getEventStageFormDataFastApi(eventId:string): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(`${this.fast_api_url}/events/${eventId}/stages/form-data`, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  getAllStagesFastApi(eventId?: string): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(`${this.fast_api_url}/events/${eventId}/stages`, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  
  getStageFastApi(eventId?: string, stageId?: string): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(`${this.fast_api_url}/stages/${eventId}/${stageId}`, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  
  addStageFastApi(payload: any,eventId:string): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(`${this.fast_api_url}/events/${eventId}/stages`, payload, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  
  deleteStageFastApi(stageId: string, eventId:string): Observable<HttpResponse<any>> {
    return this.http.delete<HttpResponse<any>>(`${this.fast_api_url}/events/${eventId}/stages/${stageId}`, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  
  updateStageFastApi(stageId: string, payload: any): Observable<HttpResponse<any>> {
    return this.http.put<HttpResponse<any>>(`${this.fast_api_url}/events/${payload.event_uuid}/stages/${stageId}`, payload, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  regenerateWalkInKeyFastApi(eventId: string, stageId: string): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(`${this.fast_api_url}/events/${eventId}/stages/${stageId}/walk-in/regenerate-key`, {}, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  reorderStagesFastApi(eventId: string, stageUuids: string[]): Observable<HttpResponse<any>> {
    return this.http.put<HttpResponse<any>>(`${this.fast_api_url}/events/${eventId}/stages/reorder`, 
      { stage_uuids: stageUuids },
      { observe: 'response' }
    ).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  // STAGE RULE APIs
  getStageRuleFormDataFastApi(stageId: string,eventId: string): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(`${this.fast_api_url}/events/${eventId}/stages/${stageId}/rules/form-data`, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  
  getAllRulesFastApi(stageId: string,eventId: string): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(`${this.fast_api_url}/events/${eventId}/stages/${stageId}/rules`, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  saveRuleFastApi(stageId: string,eventId: string,payload?: any): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(`${this.fast_api_url}/events/${eventId}/stages/${stageId}/rules`, payload, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  
  deleteRuleFastApi(ruleId: string,stageId: string,eventId: string,): Observable<HttpResponse<any>> {
    return this.http.delete<HttpResponse<any>>(`${this.fast_api_url}/events/${eventId}/stages/${stageId}/rules/${ruleId}`, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  
  updateRuleFastApi(ruleId: string,stageId: string,eventId: string, payload?: any): Observable<HttpResponse<any>> {
    return this.http.put<HttpResponse<any>>(`${this.fast_api_url}/events/${eventId}/stages/${stageId}/rules/${ruleId}`, payload, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }  

  getInterviewCandidatesByStatusFastApi(eventId: string, status: string, page = 1, size = 10, search?: any , orderBy = 'asc',stageId?:string): Observable<HttpResponse<any>> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('interview_status', status)
      .set('order_by', orderBy)

      if (search && search.trim() !== '') {
        params = params.set('s', search.trim());
      }
      if (stageId && stageId.trim() !== '') {
        params = params.set('stage_id', stageId);
      }
    return this.http.get<HttpResponse<any>>(`${this.fast_api_url}/events/${eventId}/interviews`, {
      params,
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }


  exportInterviewInsightsFastApi(eventId: string, payload: any): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(`${this.fast_api_url}/events/${eventId}/interviews/insights/export`, payload, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  assignInterviewerFastApi(eventId: string, payload: any): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(`${this.fast_api_url}/events/${eventId}/interviews/assign-interviewer`, payload, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  getCandidateResume(eventId: string, userId: string): Observable<any> {
    return this.http.get(`${this.fast_api_url}/events/${eventId}/candidates/${userId}/resume`,
      {
        observe: 'response',
      }
    ).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  getCandidateFeedback(eventId: string, candidateId: string): Observable<any> {
    return this.http.get(`${this.fast_api_url}/events/${eventId}/candidates/${candidateId}/feedback-tests/details`, {
      observe: 'response'
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
}

getCandidateActivity(eventId: string, candidateId: string): Observable<any> {
  return this.http.get(`${this.fast_api_url}/events/${eventId}/candidates/${candidateId}/activity`, {
    observe: 'response'
  }).pipe(
    catchError(this.globalService.handleError.bind(this.globalService))
  );
}

getCandidateForms(eventId: string, candidateId: string): Observable<any> {
  return this.http.get(`${this.fast_api_url}/events/${eventId}/candidates/${candidateId}/forms`, {
    observe: 'response',
  }).pipe(
    catchError(this.globalService.handleError.bind(this.globalService))
  );
}

getCandidateFormDetails(eventId: string, formType: string, formId: number): Observable<any> {
  return this.http.get(`${this.fast_api_url}/events/${eventId}/forms/${formType}/${formId}/details`, {
    observe: 'response',
  }).pipe(
    catchError(this.globalService.handleError.bind(this.globalService))
  );
}
getCandidateInfo(candidateId: string, eventId: string, eventDetailsRequired: boolean = true): Observable<HttpResponse<any>> {
  return this.http.get<HttpResponse<any>>(
    `${this.fast_api_url}/candidates/${candidateId}/events/${eventId}?event_details_required=${eventDetailsRequired}`, {
      observe: 'response',
    }
  ).pipe(
    catchError(this.globalService.handleError.bind(this.globalService))
  );
}

downloadCandidateAttachments(eventId: string, formType: string,formId: number): Observable<any> {
  const url = `${this.fast_api_url}/events/${eventId}/forms/${formType}/${formId}/download`;
  return this.http.get(url, {
    observe: 'response',
    responseType: 'blob',
  }).pipe(
    catchError(this.globalService.handleError.bind(this.globalService))
  );
}

  // Dashboard data
  getDashboardSummary(range = 30): Observable<any> {
    const params = new HttpParams().set('range', range.toString());
    return this.http.get<any>(`${this.hire_pulse_url}/metrics/dashboard/summary`, { params }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  getDashboardCharts(range = 30): Observable<any> {
    const params = new HttpParams().set('range', range.toString());
    return this.http.get<any>(`${this.hire_pulse_url}/metrics/dashboard/charts`, { params }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  getDashboardAnalytics(range = 30): Observable<any> {
    const params = new HttpParams().set('range', range.toString());
    return this.http.get<any>(`${this.hire_pulse_url}/metrics/dashboard/analytics`, { params }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  getDashboardRecruitmentFunnel(range = 30): Observable<any> {
    const params = new HttpParams().set('range', range.toString());
    return this.http.get<any>(`${this.hire_pulse_url}/metrics/dashboard/recruitment-funnel`, { params }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  // Access management for event

getSpecificEventFastApi(eventId: string): Observable<HttpResponse<any>> {
  return this.http.get<HttpResponse<any>>(this.fast_api_url + '/events/' + eventId, {
    observe: 'response',
  }).pipe(
    catchError(this.globalService.handleError.bind(this.globalService))
  );
}

saveRoleWithMembers(eventId: string, payload: any): Observable<HttpResponse<any>> {
  return this.http.post<HttpResponse<any>>(`${this.fast_api_url}/events/${eventId}/roles`, payload, {
    observe: 'response',
  }).pipe(
    catchError(this.globalService.handleError.bind(this.globalService))
  );
}
addMembersToRole(eventId: string, roleId: number, payload: { user_id: number[] }[]): Observable<any> {
  return this.http.put<any>(
    `${this.fast_api_url}/events/${eventId}/access-management`,
    payload,
    {
      observe: 'response',
    }
  ).pipe(
    catchError(this.globalService.handleError.bind(this.globalService))
  );
}
deleteEventRole(eventId: string, roleId: number): Observable<HttpResponse<any>> {
  return this.http.delete<HttpResponse<any>>(`${this.fast_api_url}/events/${eventId}/access-management/${roleId}`, {
    observe: 'response',
  }).pipe(
    catchError(this.globalService.handleError.bind(this.globalService))
  );
}
getRoleAndPermissionFastApi(): Observable<HttpResponse<any>> {
  return this.http.get<HttpResponse<any>>(`${this.fast_api_url}/roles`, {
    observe: 'response',
  }).pipe(
    catchError(this.globalService.handleError.bind(this.globalService))
  );
}
}
